<template>
  <div class="mc-video-alert__video-item-state video-request">
    <div class="mc-video-alert__content-wrapper">
      <template v-if="isDmsAdas || isNewRequestUi">
        <McButton
          icon="icon-outline_download"
          variant="outline-primary"
          size="small"
          class="btn-download-video dms-adas"
          :text="'Request Video'"
          :disabled="disabled"
          @click="$emit('clickRequestVideo')"
        />
      </template>
      <template v-else>
        <i class="mc-fa icon-fill_videorecord"></i>
        <p>{{ $t('global.noVideo') }}</p>
        <McButton
          :disabled="disabled"
          icon="icon-outline_download"
          variant="primary"
          size="small"
          class="btn-download-video general-driver-behavior"
          :text="'Request Video'"
          @click="$emit('clickRequestVideo')"
        />
      </template>
    </div>
  </div>
</template>
<script>
import McButton from '@/components/McButton'

export default {
  components: {
    McButton,
  },
  props: {
    isDmsAdas: {
      type: Boolean,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: true,
    },
    isNewRequestUi: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ['clickRequestVideo'],
}
</script>

<style lang="scss">
.mc-video-alert__video-item-state.video-request {
  button {
    i {
      margin-bottom: 0;
    }
  }

  .btn-download-video.general-driver-behavior {
    button {
      background-color: $mep-primary;
    }
  }
  .btn-download-video.dms-adas {
    button {
      background-color: $white;
      &:hover:not(:disabled),
      &:focus:not(:disabled) {
        span {
          color: $white;
        }
      }
    }
    span {
      color: $mep-primary;
    }
  }
}
</style>
